import { Chip } from '@mui/material';

/** "Showing one <noun> (from a link)" chip for a list filtered by `useFocusedRow`. Renders nothing without a focus. */
export default function FocusedRowChip({ focusId, noun, onClear }: { focusId: string | null; noun: string; onClear: () => void }) {
    if (!focusId) return null;
    return (
        <Chip sx={{ mb: 2, alignSelf: 'flex-start' }} label={`Showing one ${noun} (from a link). Click to show all`}
            onClick={onClear} onDelete={onClear} data-testid="focused-row-chip" />
    );
}
